import Vue from 'vue'
import MobileDetect from 'mobile-detect'

const UA = window.navigator.userAgent.toLowerCase()
const md = new MobileDetect(UA)
const platform = window.navigator.platform.toLowerCase()
const isRealAndroid = /(linux armv8l|linux armv7l|linux aarch64)/i.test(platform)
const isRealiOS = /(iphone|ipad|ipod|ios)/i.test(platform)
const isRealMobile = isRealAndroid || isRealiOS

const Bus = new Vue({
  data: {
    style: {
      blueColor: '#335dff'
    },
    sev: {
      init: false // 初始化
    },
    UA,
    platform,
    // 手机型号
    model: md.mobile(),
    // 是否是在app中
    isApp: /leelenapp/i.test(UA),
    // 是否是在运营平台app中
    isCRM: /leelenappcrm/i.test(UA),
    // 是否是在乐比邻app中
    isLBL: /leelenapplbl/i.test(UA),
    // 是否是真的移动端
    isRealMobile,
    // 是否是模拟移动端
    isMobile: isRealMobile || !!md.mobile(),
    // 是否是真实安卓移动端
    isRealAndroid,
    // 是否是真实安卓移动端位
    isAndroid32: /linux armv7l/i.test(platform),
    // 是否是模拟安卓移动端
    isAndroid: isRealAndroid || md.os() === 'AndroidOS',
    // 是否是真实苹果移动端
    isRealiOS,
    // 是否是模拟苹果移动端
    isiOS: isRealiOS || md.os() === 'iOS',
    // 系统版本
    osVersion: md.version('iPhone') || md.version('Android'),
    // 是否是百度浏览器
    isBaidu: /baidu/i.test(UA),
    // 是否是微信浏览器
    isWeixin: /micromessenger/i.test(UA)
  },
  methods: {
    emit(event, ...args) {
      this.$emit(event, ...args)
    },
    on(event, callback) {
      this.$emit(event, callback)
    },
    off(event, callback) {
      this.$emit(event, callback)
    }
  }
})

console.log('系统信息', Bus)

export default Bus
